import { Box } from "@mui/material";
import { Color } from "types/colors";
import { useIntl } from "react-intl";
import GenericContentBox from "./GenericContentBox";

type RequestResponseBoxProps = {
  requestObject?: string;
  responseObject?: string;
};

export default function RequestResponseBox({
  requestObject,
  responseObject,
}: RequestResponseBoxProps) {
  const { formatMessage: t } = useIntl();

  return (
    <Box mr={2}>
      <GenericContentBox
        value={requestObject}
        title={t({ id: "request" })}
        color={Color.LightGreenLighter}
      />

      <GenericContentBox
        value={responseObject}
        title={t({ id: "response" })}
        color={Color.LightBlueLighter}
      />
    </Box>
  );
}
